// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"dc9e8b2d","453":"c7530fd7","523":"348d0a9d","734":"3fb03da4","790":"03df8c4c","795":"dd70697a"}[chunkId] + ".chunk.js";
};